import { Helmet } from 'react-helmet-async';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ForgotPasswordForm from '@/pages/forgot-password/ForgotPasswordForm';
import HeroLayout from '@/components/shared/hero/HeroLayout';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import HeroTransparentCardLayout from '@/components/shared/hero/HeroTransparentCardLayout';
import ForgotPasswordSuccess from '@/pages/forgot-password/ForgotPasswordSuccess';

function ForgotPassword() {
  const intl = useIntl();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <>
      <Helmet>
        <title>LuckyDays - {intl.formatMessage({ id: 'forgot.title' })}</title>
      </Helmet>
      <HeroLayout fullHeight={true} isAuthenticated={isAuthenticated}>
        <HeroTransparentCardLayout
          heading={
            <FormattedMessage
              id={
                isSuccess
                  ? 'authentication.forgot-password-success.header'
                  : 'authentication.forgot-password.header'
              }
              values={{
                span: str => <span className="text-blue-light">{str}</span>,
              }}
            />
          }
        >
          {!isSuccess && <ForgotPasswordForm onSuccessCallback={() => setIsSuccess(true)} />}
          {isSuccess && <ForgotPasswordSuccess />}
        </HeroTransparentCardLayout>
      </HeroLayout>
    </>
  );
}

export default ForgotPassword;
